/**
 * #1408 — Paul's ruling (2026-10-01): a customer can pay at ANY point in their trial.
 * A signed-in customer pressing a checkout button IS the explicit paid-checkout step
 * the server asks for (#1308 `paid_checkout_consent`), so every signed-in checkout
 * request says so. Without it a trial with under 48 h left was refused with a 409.
 * Signed-out (marketing) requests are unchanged.
 */
export function withPaidCheckoutConsent<T extends Record<string, unknown>>(
  body: T,
  signedIn: boolean,
): T & { paid_checkout_consent?: true } {
  return signedIn ? { ...body, paid_checkout_consent: true as const } : body;
}
